import ResizeObserver from 'resize-observer-polyfill'

export default {
  methods: {
    createdResizeObserver (cb) {
      if (!cb) return
      this.resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) { cb(entry) }
      })
      this.resizeObserver.observe(this.$el)
    }
  },
  beforeDestroy () {
    this.resizeObserver && this.resizeObserver.unobserve(this.$el)
  }
}